<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>{{task.Name}}</mat-panel-title>
    </mat-expansion-panel-header>
    <mat-stepper #stepper [linear]="true">
      <mat-step label="Schedule Type">
        <maintenance-recurrence #recurrence (scheduleModeChanged)="onScheduleModeChanged($event)"></maintenance-recurrence>
        <maintenance-schedule-preview [occurrences]="previewOccurrences"></maintenance-schedule-preview>
        <div>
          @if (scheduleMode === 'Recurring') {
            <button mat-button (click)="previewRecurring(recurrence.buildRecurrenceRequest(getCreatorTimeZoneId()))">Preview</button>
          }
          <button mat-button matStepperNext [disabled]="!recurrence.isValid()">Next</button>
        </div>
      </mat-step>
      @if (scheduleMode === 'OneTime') {
        <mat-step [stepControl]="startDateStep" label="Start Date">
          <form [formGroup]="startDateStep">
            <mat-form-field>
              <input matInput placeholder="Start Date" type="datetime-local" formControlName="startdate">
              <mat-hint>Times are entered in your timezone ({{getCreatorTimeZoneId()}}) and saved in UTC.</mat-hint>
            </mat-form-field>
            <div>
              <button mat-button matStepperPrevious>Previous</button>
              <button mat-button matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>
      }
      <mat-step [stepControl]="tenantSelectionStep" label="Select Tenants">
        <tenants-selection [allTenants$]="allTenants$" (selectionChanged)="onSelectedTenantsChange($event)"></tenants-selection>
        <div>
          <button mat-button matStepperPrevious>Previous</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step label="Config">
        <maintenance-task-config [task]="task"></maintenance-task-config>
        <div>
          <button mat-button matStepperPrevious>Previous</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step label="Submit Job">
        <div>
          <button mat-button matStepperPrevious>Previous</button>
          @if (scheduleMode === 'OneTime') {
            <button type="submit" mat-raised-button color="primary" (click)="submit()">Submit Job</button>
          }
          @if (scheduleMode === 'Recurring') {
            <button type="submit" mat-raised-button color="primary" (click)="submitRecurring(recurrence.buildRecurrenceRequest(getCreatorTimeZoneId()))">Submit Recurring Job</button>
          }
        </div>
      </mat-step>
    </mat-stepper>
  </mat-expansion-panel>
</mat-accordion>
